var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDishes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_685",
    "data-name": "Group 685",
    transform: "translate(-29 -403)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M425.069,360.476a19.475,19.475,0,0,0-15.563-18.995,3.673,3.673,0,0,0-7.318,0,19.488,19.488,0,0,0-15.555,18.995,1.5,1.5,0,0,0-1.252,1.487v1.947a1.5,1.5,0,0,0,1.482,1.509h37.97a1.5,1.5,0,0,0,1.481-1.509v-1.947A1.5,1.5,0,0,0,425.069,360.476ZM405.846,344.25a15.93,15.93,0,0,0-15.763,16.059.556.556,0,1,1-1.111,0,17.055,17.055,0,0,1,16.874-17.191.566.566,0,0,1,0,1.132Zm0-3.124a17.722,17.722,0,0,0-2.111.121,2.19,2.19,0,0,1,4.222,0A17.811,17.811,0,0,0,405.846,341.126Z",
    transform: "translate(-354.106 73.966)",
    fill: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3986",
    "data-name": "Rectangle 3986",
    width: 45,
    height: 45,
    transform: "translate(29 403)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDishes);
export default __webpack_public_path__ + "static/media/dishes.f944096a8df534bfa03a69c4e97db5c2.svg";
export { ForwardRef as ReactComponent };